export const ACTIONS = {
  CHANGE_CAR_INSTANCE: 'car-instance/change',
  CHANGE_DEALERS_PARAMS: 'car-instance/change-dealers-params',
  CLEAR_CAR_INSTANCE: 'car-instance/clear',
  CLEAR_SCROLL_TO_INSTANCE: 'car-instance/clear-scroll-to',
  CLOSE_BLOCK: 'car-instance/close-block',
  CLOSE_DETAILS: 'car-instance/close-details',
  DECLINE_DROP_ERRORS: 'car-instance/decline-drop-errors',
  DISABLE: 'car-instance/disable',
  DROP_ERRORS_CAR_INSTANCE: 'DROP_ERRORS_CAR_INSTANCE',
  DROP_ONE_ERROR_CAR_INSTANCE: 'DROP_ONE_ERROR_CAR_INSTANCE',
  ENABLE: 'car-instance/enable',
  FORCE_VALIDATE_CAR_INSTANCE: 'car-instance/force-validate-complete',
  GET_CAR_INSTANCE: 'GET_CAR_INSTANCE',
  GET_CAR_INSTANCE_BY_ID: 'car-instance/get-by-id',
  GET_DEALERS_PARAMS: 'car-instance/get-dealers-params',
  OPEN_BLOCK: 'car-instance/open-block',
  OPEN_DETAILS: 'car-instance/open-details',
  PATCH_CAR_INSTANCE: 'PATCH_CAR_INSTANCE',
  PATCH_IS_NEW: 'car-instance/patch-is-new',
  SCROLL_TO_INSTANCE: 'car-instance/scroll-to',
  SET_CAR_DISABLE_FIELDS: 'car-instance/set-car-disable-fields',
  SET_CAR_HIDDEN_FIELDS: 'car-instance/set-car-hidden-fields',
  SET_CAR_INSTANCE: 'SET_CAR_INSTANCE',
  SET_CAR_REQUIRED_FIELDS: 'car-instance/set-car-required-fields',
  SET_COLLAPSABLE: 'car-instance/set-collapsable',
  SET_ERROR_CAR_INSTANCE: 'SET_ERROR_CAR_INSTANCE',
  SET_FETCH_CAR_INFO: 'cr-instance/set-fetch-car-info',
  SET_FETCH_CAR_INSTANCE: 'SET_FETCH_CAR_INSTANCE',
  SET_FETCH_DEALERS_PARAMS: 'car-instance/set-fetch-dealers-params',
  SET_IMAGE: 'car-instance/set-image',
  SET_PATCHIG_CAR_INSTANCE: 'car-instance/patching',
  UPDATE_CAR_INSTANCE_ID: 'car-instance/update-id',
  UPDATE_ERRORS_CAR_INSTANCE: 'UPDATE_ERRORS_CAR_INSTANCE',
  VALIDATE_CAR_INSTANCE: 'car-instance/validate',
  UPDATE_NESTED_ERRORS: 'car-instance/update-nested-errors',
  UPDATE_NESTED_VALUES: 'car-instance/update-nested-values',
};
